"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PlaybackWaiting = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _PlaybackWaiting = require("./PlaybackWaiting.styled");
var PlaybackWaiting = exports.PlaybackWaiting = function PlaybackWaiting(_ref) {
  var message = _ref.message;
  return /*#__PURE__*/_react["default"].createElement(_PlaybackWaiting.StyledLabel, {
    className: "playback-waiting-message"
  }, message);
};
PlaybackWaiting.propTypes = {
  message: _propTypes.string.isRequired
};